// LOADER
window.addEventListener('load', function () {
	document.body.classList.add('loaded'); // FULLY LOADED
});

setTimeout(() => {
	document.body.classList.add('loaded'); // TIMEOUT
}, 2000);
// =========

document.addEventListener('DOMContentLoaded', function () {
	setTimeout(() => {
		document.body.classList.add('loaded'); // ALMOST LOADED
	}, 500);

	//===============

	const idPrefix = 's';
	const timerDuration = 60 * 5 - 1;
	let startStep = 4;
	const circleProgressDuration = 6000 / 100; // 100% in 6 seconds

	const _currentStep = sessionStorage.getItem('currentStep'),
		currentStep = _currentStep != null ? Number(_currentStep) : null;

	const currentUrl = new URL(window.location.href),
		_showPaywall = currentUrl.searchParams.get('paywall'),
		showPaywall = _showPaywall ? Boolean(_showPaywall) : null;

	const _variation = currentUrl.searchParams.get('variation'),
		variation = !_variation ? 'w' : _variation === '2' ? 'm' : 'w';
	document.querySelector('body').classList.add(variation);

	const answers = [];

	//===============

	let userWeight,
		userGoalWeight,
		userHeight,
		userAge,
		// userAgree,
		userBmi,
		userBmiText,
		bodyType = 'Mesomorph',
		lifeStyle = 'Active',
		fitnessLevel = 'Basic',
		metabolism = 'Moderate',
		outOfTime = false;

	let userEmail = sessionStorage.getItem('currentEmail') ? sessionStorage.getItem('currentEmail') : '';
	let userName = sessionStorage.getItem('currentName') ? sessionStorage.getItem('currentName') : '';

	const pbStart = 4, // show progress bar at
		pbEnd = 23; // hide progress bar after

	let pbExclude = [7, 12];
	if (variation === 'm') {
		pbExclude = [7, 12, 20, 21];
	}

	setupProgressBar();

	// const
	// 	minFt = 3,
	// 	maxFt = 7,
	// 	minIn = 0,
	// 	maxIn = 11,
	// 	minCm = 90,
	// 	maxCm = 243,
	// 	minLbs = 55,
	// 	maxLbs = 662,
	// 	minKg = 25,
	// 	maxKg = 300,
	// 	minAge = 16,
	// 	maxAge = 99;

	//===============

	// EMAIL VALIDATION REGEXP
	const emailRegexp =
		/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	// ===============================

	const userBucket = assignBucket();
	console.log('User assigned to bucket:', userBucket);
	const showsLoader = false;
	const paywallType = 'v-selector';

	// displayContentForBucket(userBucket);

	initAnalytics();
	identifyUser({
		session_id: getSessionId(),
		variation: variation,
		paywall_type: paywallType,
		shows_loader: showsLoader,
	});
	reportPageView();

	const jumpToStep = showPaywall ? 34 : currentStep ?? startStep;
	setActiveStage(1, jumpToStep);

	setupEventListeners();

	function setupProgressBar() {
		for (let i = pbStart; i <= pbEnd; i++) {
			document
				.querySelector('.js_quprogress')
				.insertAdjacentHTML('beforeend', `<div class="qu-progress__bar"></div>`);
		}
		for (let i = 0; i < pbExclude.length; i++) {
			const hideStep = pbExclude[i] - pbStart + 1;

			document.querySelector(`.qu-progress__bar:nth-child(${hideStep})`).classList.add('hidden');
		}
	}

	function assignBucket() {
		// Check if query params contain a bucket
		const paramsBucket = currentUrl.searchParams.get('bucket');
		if (paramsBucket && (paramsBucket === 'A' || paramsBucket === 'B')) {
			// Save the bucket assignment to session storage
			sessionStorage.setItem('userBucket', paramsBucket);
			return paramsBucket;
		}

		// Check if the user already has a bucket assignment in session storage
		const existingBucket = sessionStorage.getItem('userBucket');

		if (existingBucket) {
			return existingBucket;
		}

		const randomNumber = Math.random();
		// const newBucket = randomNumber < 0.8 ? 'A' : 'B';
		const newBucket = 'A';

		// Save the bucket assignment to session storage
		sessionStorage.setItem('userBucket', newBucket);

		return newBucket;
	}

	function getCheckedPlan() {
		let radioButtons = document.querySelectorAll('input[name="getplan"]');
		for (let i = 0; i < radioButtons.length; i++) {
			if (radioButtons[i].checked) {
				return radioButtons[i].id;
			}
		}
		return null; // Return null if no radio button is checked (optional)
	}

	function initiateCheckout(plan) {
		getCheckoutLinkAndReport(plan, userEmail, userName).then((checkoutLink) => {
			if (checkoutLink) {
				window.location.href = checkoutLink;
			}
		});
	}

	function displayContentForBucket(userBucket) {
		const contentAElements = document.querySelectorAll('.contentA');
		const contentBElements = document.querySelectorAll('.contentB');

		if (userBucket === 'A') {
			contentAElements.forEach((el) => el.classList.remove('hidden'));
			contentBElements.forEach((el) => el.classList.add('hidden'));
		} else {
			contentAElements.forEach((el) => el.classList.add('hidden'));
			contentBElements.forEach((el) => el.classList.remove('hidden'));
		}
	}

	function enforceMinMax(el) {
		if (el.value != '') {
			if (parseInt(el.value) < parseInt(el.min)) {
				el.value = el.min;
			}
			if (parseInt(el.value) > parseInt(el.max)) {
				el.value = el.max;
			}
		}
		checkFill(el);
	}

	// INPUT STATUS
	function checkFill(item) {
		item.value.length ? item.classList.add('m-filled') : item.classList.remove('m-filled');

		const currentId = item.id,
			currentNext = item.closest('section').querySelector('.js_qunext');

		if (item.classList.contains('js_checkminmax')) {
			// console.log(item.value);
			if (parseInt(item.value) >= parseInt(item.min) && parseInt(item.value) <= parseInt(item.max)) {
				item.classList.add('m-passed');
				currentNext.removeAttribute('disabled');
			} else {
				item.classList.remove('m-passed');
				currentNext.disabled = 'disabled';
			}
		}

		if (item.id === 'input-name') {
			if (item.value.length) {
				document.querySelector('.js_getname').removeAttribute('disabled');
			} else {
				document.querySelector('.js_getname').disabled = 'disabled';
			}
		}
	}

	function validateEmail(email) {
		const re = emailRegexp;
		return re.test(email);
	}

	function listenEmail(email) {
		if (validateEmail(email)) {
			document.querySelector('.js_getmail').removeAttribute('disabled');
		} else {
			document.querySelector('.js_getmail').disabled = 'disabled';
		}
	}

	function setProgressBar(currentId, nextId) {
		if (nextId >= pbStart && nextId <= pbEnd) {
			if (nextId > startStep) {
				document.body.classList.add('qu-showback');
			} else {
				document.body.classList.remove('qu-showback');
			}

			if (currentId > nextId) {
				document
					.querySelector(`.js_quprogress .qu-progress__bar:nth-child(${currentId - pbStart + 1})`)
					.classList.remove('m-done');
			}
			document
				.querySelector(`.js_quprogress .qu-progress__bar:nth-child(${nextId - pbStart + 1})`)
				.classList.add('m-done');

			for (let i = 0; i < pbExclude.length; i++) {
				const hideStep = pbExclude[i];
				if (nextId === hideStep) {
					document.body.classList.remove('qu-showprogress', 'qu-showback');
					return;
				}
			}

			document.body.classList.add('qu-showprogress');
		} else {
			document.body.classList.remove('qu-showprogress', 'qu-showback');
		}
	}

	function setFooter(nextId) {
		if (nextId !== 1 && nextId !== 2 && nextId !== 34) {
			document.body.classList.add('qu-hidefooter');
		} else {
			document.body.classList.remove('qu-hidefooter');
		}
	}

	function setFocus() {
		const currentStage = document.querySelector('.qu-section.m-active');
		if (currentStage.querySelectorAll('.qu-input__input, .qu-mail__input').length > 0) {
			currentStage.querySelector('.qu-input__input, .qu-mail__input').focus();
		}

		if (currentStage.querySelector('[data-current="ft"]')) {
			const currentRadio = currentStage.querySelector('.qu-switcher__radio:checked').getAttribute('data-current');
			if (currentRadio === 'ft') {
				document.getElementById('input-height-ft').focus();
			} else if (currentRadio === 'cm') {
				document.getElementById('input-height-cm').focus();
			} else {
				trigger.closest('section').querySelector('.qu-input__input, .qu-mail__input').focus();
			}
		}
		if (currentStage.querySelector('[data-current="lbs"]')) {
			const currentRadio = currentStage.querySelector('.qu-switcher__radio:checked').getAttribute('data-current');

			if (currentRadio === 'lbs') {
				document.querySelectorAll('#input-weight-lbs, #input-goalweight-lbs').forEach((item) => {
					item.focus();
				});
			} else if (currentRadio === 'kg') {
				document.querySelectorAll('#input-weight-kg, #input-goalweight-kg').forEach((item) => {
					item.focus();
				});
			} else {
				trigger.closest('section').querySelector('.qu-input__input, .qu-mail__input').focus();
			}
		}
	}

	function getStepName(stepId) {
		const stepMap = {
			34: 'paywall',
		};

		return stepMap[stepId] || stepId;
	}

	function getCurrentId() {
		const currentStage = document.querySelector('.qu-section.m-active');
		const currentId = currentStage ? Number(currentStage.id.substring(idPrefix.length)) : null;
		return currentId;
	}

	function setActiveStage(direction, jumpTo) {
		const currentId = getCurrentId();

		if (direction === -1) {
			trackEvent('BackPressed', {
				step: getStepName(currentId),
			});
		}

		let nextId = jumpTo ? jumpTo : currentId + direction;

		if (currentId === 8 && direction === -1) {
			nextId = 6;
		}

		if (currentId === 13 && direction === -1) {
			nextId = 11;
		}

		if (currentId === 23 && direction === 1) {
			nextId = 29;
		}

		if (currentId === 30 && direction === 1) {
			nextId = 32;
		}
		if (currentId === 32 && direction === -1) {
			nextId = 30;
		}

		if (currentId === 32 && direction === 1) {
			nextId = 34;
		}
		if (currentId === 34 && direction === -1) {
			nextId = 32;
		}

		if (currentId === 19 && direction === 1 && variation === 'm') {
			nextId = 22;
		}
		if (currentId === 22 && direction === -1 && variation === 'm') {
			nextId = 19;
		}

		const currentElement = document.getElementById(`${idPrefix}${currentId}`),
			nextElement = document.getElementById(`${idPrefix}${nextId}`);

		if (nextElement) {
			currentElement?.classList.remove('m-active');
			nextElement.classList.add('m-active');
		} else {
			console.log(`Invalid next step ${nextId}`);
			return;
		}

		if (nextId === 2) {
			init2();
		}

		if (nextId === 25) {
			firstTry = false;
		}

		if (nextId === 29) {
			init29();
		}

		if (nextId === 34) {
			init34();
		}

		// last step only
		if (nextId == 34) {
			sessionStorage.setItem('currentStep', nextId);
			document.body.classList.add('qu-laststep');
		} else {
			document.body.classList.remove('qu-laststep');
		}

		setProgressBar(currentId, nextId);
		setFooter(nextId);
		setFocus();

		trackEvent('StepView', {
			step: getStepName(nextId),
		});
	}

	function saveAnswer(trigger) {
		const header = document.querySelector('.qu-section.m-active > div > .qu-h2');
		const id = trigger.closest('section').id;
		const headerText = header ? header.outerText : '';
		const buttonPressed = trigger.outerText;

		// Select all checkboxes within the container
		const checkboxes = document.querySelectorAll(
			'.qu-section.m-active > div > .qu-middle > .qu-squ__grid .qu-squ__check',
		);

		// Initialize an array to store the selected IDs
		const selectedIds = [];
		checkboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				selectedIds.push(checkbox.id);
			}
		});

		answers.push({
			id: id,
			headerText: headerText,
			selectedIds: selectedIds,
			buttonPressed: buttonPressed,
			ts: Date.now(),
		});
		sessionStorage.setItem('answers', JSON.stringify(answers));
	}

	function init2() {
		const downloadBar = document.querySelector('.qu-download__bar'),
			downloadValue = document.querySelector('.qu-download__value'),
			duration = 100,
			steps = 1;
		let currentProgess = 0;

		const timer = setInterval(function () {
			currentProgess += steps;

			downloadBar.style.setProperty('--progr-perc', `${currentProgess}%`);
			downloadValue.innerHTML = `${currentProgess}%`;

			if (currentProgess >= 50) {
				downloadValue.style.color = '#fff';
			}

			if (currentProgess >= duration) {
				clearInterval(timer);
				downloadBar.closest('section').querySelector('.js_qunext').removeAttribute('disabled');
				setTimeout(() => {
					const currentId = getCurrentId();
					if (currentId !== 2) {
						return;
					}
					downloadBar.closest('section').querySelector('.js_qunext').click();
				}, 1500);
			}
		}, circleProgressDuration);
	}

	function init29() {
		if (typeof Swiper !== 'undefined') {
			const swiper = new Swiper('.js_qu-fb_swiper', {
				slidesPerView: 1,
				spaceBetween: 8,
				resistanceRatio: 0,
				loop: true,
				autoplay: true,
			});
		}
		const creatingCircle = document.querySelector('.qu-radial__circle'),
			creatingDigital = document.querySelector('.qu-radial__val'),
			duration = 100,
			steps = 1;
		let currentProgess = 0;

		const timer = setInterval(function () {
			currentProgess += steps;
			creatingCircle.style.setProperty('--progr-perc', `${currentProgess / 100}turn`);
			creatingDigital.innerHTML = `${currentProgess}%`;
			if (currentProgess >= duration) {
				clearInterval(timer);
				creatingCircle.closest('section').querySelector('.js_qunext').removeAttribute('disabled');
				setTimeout(() => {
					if (getCurrentId() !== 29) {
						return;
					}
					creatingCircle.closest('section').querySelector('.js_qunext').click();
				}, 1500);
			}
		}, circleProgressDuration);
	}

	function init34() {
		var duration = timerDuration,
			display = document.querySelector('.js_countdown');
		startTimer(duration, display);
		setUserName();
	}

	function setUserName() {
		if (userName) {
			document.querySelectorAll('.js_user-name').forEach((item) => {
				item.innerHTML = userName;
			});
			document.querySelectorAll('[data-current="titleWithName"]').forEach((item) => {
				item.classList.remove('hidden');
			});
			document.querySelectorAll('[data-current="titleWithoutName"]').forEach((item) => {
				item.classList.add('hidden');
			});
		} else {
			document.querySelectorAll('[data-current="titleWithoutName"]').forEach((item) => {
				item.classList.remove('hidden');
			});
		}
	}

	function startTimer(duration, display) {
		let countdownTimer = duration,
			minutes,
			seconds;
		const countdown = setInterval(function () {
			minutes = parseInt(countdownTimer / 60, 10);
			seconds = parseInt(countdownTimer % 60, 10);

			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;

			display.textContent = minutes + ':' + seconds;

			if (--countdownTimer < 0) {
				// timer = duration;
				clearInterval(countdown);
				timesUp();
			}
		}, 1000);
	}

	function timesUp() {
		document.querySelectorAll('.qu-getplan__price-perday').forEach((item) => {
			const pricePerDay = item.innerHTML;
			item.closest('.qu-getplan__label').querySelector('.qu-getplan__perday-price').innerHTML = pricePerDay;

			item.remove();
		});

		document.querySelectorAll('.qu-getplan__price-current,.qu-getplan__note').forEach((item) => {
			item.remove();
		});
		document.querySelectorAll('.qu-getplan__price-old').forEach((item) => {
			item.classList.add('qu-getplan__price-current');
			item.classList.remove('qu-getplan__price-old');
		});

		outOfTime = true;
	}

	function setupEventListeners() {
		document.querySelectorAll('.js_getplan').forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				const plan = getCheckedPlan();
				initiateCheckout(plan);
			});
		});

		document.querySelectorAll('.js_getplan_dblclick').forEach((trigger) => {
			const plan = trigger.getAttribute('for');

			trigger.addEventListener('click', (e) => {
				const selectedPlan = getCheckedPlan();

				if (plan === selectedPlan) {
					initiateCheckout(plan);
				}
			});
		});

		// click next/prev
		document.querySelectorAll('.js_qunext, .js_quback').forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				if (trigger.classList.contains('js_qunext')) {
					saveAnswer(trigger);
				}

				e.preventDefault();
				const direction = trigger.classList.contains('js_quback') ? -1 : 1;

				document.body.classList.add('qu-holdit');
				setTimeout(() => {
					document.body.classList.remove('qu-holdit');
					setActiveStage(direction);
				}, 100);

				if (trigger.id === `${idPrefix}13_a1` || trigger.id === `${idPrefix}13_a2`) {
					lifeStyle = 'Active';
				}
				if (trigger.id === `${idPrefix}13_a3` || trigger.id === `${idPrefix}13_a4`) {
					lifeStyle = 'Sedentary';
				}

				if (trigger.id === `${idPrefix}14_a1`) {
					bodyType = 'Ectomorph';
					metabolism = 'Fast, difficult to gain muscle';
				}
				if (trigger.id === `${idPrefix}14_a2`) {
					bodyType = 'Mesomorph';
					metabolism = 'Moderate, challenging to stay trim';
				}
				if (trigger.id === `${idPrefix}14_a3`) {
					bodyType = 'Endomorph';
					metabolism = 'Slow, easy to gain weight';
				}
			});
		});

		document.querySelector('.js_getname').addEventListener('click', (e) => {
			userName = document.getElementById('input-name').value;
			sessionStorage.setItem('currentName', userName);
			reportEmail(userEmail, userName, answers);
		});

		// =============

		// EMAIL STAGE COMPLETE
		document.querySelector('.js_getmail').addEventListener('click', (e) => {
			userEmail = document.getElementById('input-email').value;
			sessionStorage.setItem('currentEmail', userEmail);
			identifyUser({ email: userEmail });
		});

		// =============

		document.querySelectorAll('.js_checkfill').forEach((item) => {
			checkFill(item);
			item.onfocus = function () {
				checkFill(item);
				item.classList.add('m-focused');
				if (item.getAttribute('type') === 'email') {
					listenEmail(item.value);
				}
			};
			item.onblur = function () {
				item.classList.remove('m-focused');
				checkFill(item);
				if (item.getAttribute('type') === 'number') {
					enforceMinMax(item);
				}
				if (item.getAttribute('type') === 'email') {
					listenEmail(item.value);
				}
			};
			item.onkeyup = function () {
				checkFill(item);
				if (item.getAttribute('type') === 'number') {
					const curVal = item.value;
					item.value = curVal.replace(/\D/g, '');
				}
				if (item.getAttribute('type') === 'email') {
					listenEmail(item.value);
				}
			};
		});

		document.querySelectorAll('.qu-input__input').forEach((input) => {
			input.addEventListener('focus', (e) => {
				input.select();
			});
		});

		let focusHold = false,
			firstTry = true;
		document.querySelectorAll('.qu-switcher__radio').forEach((trigger) => {
			trigger.addEventListener('change', (e) => {
				if (!focusHold) {
					setTimeout(() => {
						setFocus();
					}, 50);
				}

				if (firstTry) {
					focusHold = true;
					const currentRadio = trigger.getAttribute('data-current');
					if (currentRadio === 'ft') {
						document.querySelectorAll('[data-for="lbs"]').forEach((target) => {
							target.click();
						});
					} else if (currentRadio === 'cm') {
						document.querySelectorAll('[data-for="kg"]').forEach((target) => {
							target.click();
						});
					}
					focusHold = false;
					firstTry = false;
				}

				document.querySelectorAll('.js_checkfill').forEach((item) => {
					checkFill(item);
				});
			});
		});

		document.querySelector('.js_getheight').addEventListener('click', (e) => {
			const stage = e.target.closest('section'),
				checked = stage.querySelector('.qu-switcher__radio:checked');
			let height = 162;
			if (checked.getAttribute('data-current') === 'ft') {
				let ft = document.getElementById('input-height-ft').value,
					inch = document.getElementById('input-height-in').value;

				if (inch === '') {
					inch = 0;
				}

				height = ((parseInt(inch, 10) + parseInt(ft, 10) * 12) / 0.3937).toFixed(0);
			} else {
				const cm = document.getElementById('input-height-cm').value;
				height = parseInt(cm, 10);
			}
			userHeight = height;
			// console.log(userHeight);
		});

		document.querySelector('.js_getweight').addEventListener('click', (e) => {
			const stage = e.target.closest('section'),
				checked = stage.querySelector('.qu-switcher__radio:checked');
			let weight = 54;
			if (checked.getAttribute('data-current') === 'lbs') {
				const lbs = document.getElementById('input-weight-lbs').value;
				weight = (parseInt(lbs, 10) / 2.205).toFixed(0);
			} else {
				const kg = document.getElementById('input-weight-kg').value;
				weight = parseInt(kg, 10);
			}
			userWeight = weight;
			// console.log(userWeight);
		});

		document.querySelector('.js_getgoalweight').addEventListener('click', (e) => {
			const stage = e.target.closest('section'),
				checked = stage.querySelector('.qu-switcher__radio:checked');
			let goalWeight = 48;
			if (checked.getAttribute('data-current') === 'lbs') {
				const lbs = document.getElementById('input-goalweight-lbs').value;
				goalWeight = (parseInt(lbs, 10) / 2.205).toFixed(0);
			} else {
				const kg = document.getElementById('input-goalweight-kg').value;
				goalWeight = parseInt(kg, 10);
			}
			userGoalWeight = goalWeight;
			// console.log(userGoalWeight);
		});

		document.querySelector('.js_getage').addEventListener('click', (e) => {
			// const stage = e.target.closest('section');
			let age = document.getElementById('input-age').value;

			userAge = parseInt(age, 10);
			// console.log(userAge);

			userBmi = ((userWeight / userHeight / userHeight) * 10000).toFixed(1);
			// console.log(`BMI = ${userBmi}`);

			let bmiPos = ((userBmi / 80) * 100).toFixed(1);
			if (bmiPos > 100) {
				bmiPos = 100;
			}
			if (bmiPos < 0) {
				bmiPos = 0;
			}

			if (userBmi < 18.5) {
				userBmiText = 'underweight';

				if (bmiPos > 25) {
					bmiPos = 20;
				}
			} else if (18.5 <= userBmi && userBmi <= 24.9) {
				userBmiText = 'normal';

				if (bmiPos < 25) {
					bmiPos = 25;
				}
				if (bmiPos > 50) {
					bmiPos = 50;
				}
			} else if (24.9 < userBmi && userBmi <= 29.9) {
				userBmiText = 'overweight';

				if (bmiPos < 50) {
					bmiPos = 50;
				}
				if (bmiPos > 75) {
					bmiPos = 75;
				}
			} else {
				userBmiText = 'obese';
				if (bmiPos < 75) {
					bmiPos = 80;
				}
			}

			const bmiResult = `${userBmi} (${userBmiText})`;

			// console.log(bmiPos);

			document.querySelector('.js_bmiresult').insertAdjacentHTML('beforeend', bmiResult);
			document.querySelector('.js_bmiresultdot').style.setProperty('--bmi-dot', `${bmiPos}%`);

			document.getElementById('setBodyType').innerHTML = bodyType;
			document.getElementById('setLifeStyle').innerHTML = lifeStyle;
			document.getElementById('setFitnessLevel').innerHTML = fitnessLevel;
			document.getElementById('setMetabolism').innerHTML = metabolism;
		});

		// document.querySelector('.js_getimin').addEventListener('click', (e) => {
		// 	userAgree = e.target.textContent.trim();
		// 	// console.log(userAgree);
		// });
		// document.querySelector('.js_getiknow').addEventListener('click', (e) => {
		// 	userAgree = e.target.textContent.trim();
		// 	// console.log(userAgree);
		// });

		// moneyback
		document.getElementById('moneyback').addEventListener('click', function () {
			window.location.href = 'https://media-1.neatsy.ai/legal/money-back.html';
		});

		// STUFF ON SCROLL
		function onScroll() {
			// detect scroll
			const scrolledGap = 64;
			const scrollTop =
				window.scrollY !== undefined
					? window.scrollY
					: (document.documentElement || document.body.parentNode || document.body).scrollTop;
			scrollTop > scrolledGap
				? document.body.classList.add('m-scrolled')
				: document.body.classList.remove('m-scrolled');
			// =========
		}
		onScroll();
		let throttlescroll;
		window.addEventListener(
			'scroll',
			function () {
				clearTimeout(throttlescroll);
				throttlescroll = setTimeout(function () {
					onScroll();
				}, 50);
			},
			false,
		);
		// ========================

		// Listen Enter on inputs
		document.querySelectorAll('.js_checkminmax, #input-height-in, .js_checkfill').forEach((item) => {
			item.addEventListener('keyup', function (e) {
				if (e.keyCode == 13) {
					enforceMinMax(item);

					if (item.id === 'input-height-ft') {
						const nextInput = item.closest('section').querySelector('#input-height-in');
						nextInput.focus();
					} else {
						setTimeout(() => {
							const nextStep = item.closest('section').querySelector('.js_qunext:not([disabled])');
							if (nextStep) {
								if (item.id === 'input-age') {
									item.blur();
								}
								nextStep.click();
							}
						}, 100);
					}
				}
			});
		});

		// Scroll to plans
		document.querySelectorAll('.js_scrollto_getplan').forEach((item) => {
			item.addEventListener('click', function (e) {
				// Find all visible elements with the class 'qu-getplan' and 'qu-box'
				const plans = Array.from(document.querySelectorAll('.qu-getplan.qu-box')).filter((plan) => {
					const computedStyle = window.getComputedStyle(plan);
					return computedStyle.display !== 'none';
				});

				// Find the next plan from the current scroll position
				let nextPlan = plans.find((plan) => plan.getBoundingClientRect().top > 0);
				if (plans && !nextPlan) {
					nextPlan = plans[plans.length - 1];
				}

				// If a next plan is found, scroll to it
				if (nextPlan) {
					nextPlan.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
					});
				}
			});
		});
	}
});
